module.exports = __webpack_public_path__ + "img/hussaini.4b05ed68.jpg";